export const DataSourceAnalyticsConfiguration_QueryKey = {
  analyticsConfiguration: (
  ): string => {
    const queryKey = "bbnt-data-source-analytics-configuration";
    return queryKey;
  },
};
